<template>
  <div class="eventCard">
    <a :href="redirect"
       :aria-labelledby="linkDescriptionId"
       class="eventCard__clickable"></a>
    <span :id="linkDescriptionId"
          class="sr-only">
      Read more about the following event: {{ title }}
    </span>
    <div class="eventCard__col--icon">
      <font-awesome-icon :icon="['fal', 'calendar-alt']"
                         aria-hidden="true"
                         size="2x">
      </font-awesome-icon>
    </div>
    <div class="eventCard__col--content">
      <h2 class="eventCard__title">
        {{ title }}
      </h2>
      <div class="eventCard__summary">
        {{ summary }}
      </div>
      <div class="eventCard__info">
        <i class="fal fa-calendar-alt mr-2 crimson"
           aria-hidden="true"></i> {{ dateTime }}
      </div>
      <div v-if="location"
           class="eventCard__info">
        <i class="fal fa-map-marker-alt mr-2 crimson"
           aria-hidden="true"></i> {{ location }}
      </div>
      <span class="mb-2"></span>
      <div style="z-index: 100">
        <slot name="link">
          <gl-link :as-dummy="true"
                   :font-size="0.9">
            Read More <span class="sr-only"> - about this event: {{ title }}</span>
          </gl-link>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
import { v4 as uuid } from "uuid";

export default {
  name: "EventCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    summary: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      default: undefined,
    },
    redirect: {
      type: String,
      default: "#",
      required: true,
    },
  },
  computed: {
    linkDescriptionId () {
      return uuid();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/index.less";

.crimson {
  color: @crimson;
}

.eventCard {
  width: 50%;
  min-width: 300px;
  display: flex;
  padding: 32px;
  position: relative;

  @media (max-width: @lg) {
    width: 100%;
    padding: 16px;
  }

  &:hover {
    background-color: #f2f2f2;
  }

  &__clickable {
    text-decoration: none;
    color: #333;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    :hover {
      text-decoration: none;
    }
  }

  &__title {
    margin: 0 0 20px;
  }

  &__summary {
    margin: 0 0 12px;
    flex: 1;
    color: #333;
  }

  &__info {
    margin: 0 0 2px;
    font-weight: 500;
    color: #333;
  }

  &__link {
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    font-size: 0.9em;
  }

  &__col {
    &--icon {
      width: 50px;
    }

    &--content {
      flex: 3;
      display: flex;
      flex-flow: column;
    }
  }
}
</style>
